@if (topCards | async; as topcards) {
  <div class="grid w-full grid-cols-3 justify-between space-x-4">
    @for (card of topcards; track card) {
      <div class="col-span-1 items-center">
        <aux-ag-patient-driver-top-card [card]="card" />
      </div>
    }
  </div>
}
